import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {GRAPHIC_ATTRS} from "../../../../map/models";

export interface BaseDialoMapDetailDialogData {
  graphicAttr: string;
  item: any;
}

@Component({
  selector: 'app-base-dialog-map-detail',
  templateUrl: './base-dialog-map-detail.component.html',
  styleUrls: ['./base-dialog-map-detail.component.scss']
})
export class BaseDialogMapDetailComponent {

  constructor(
    public dialogRef: MatDialogRef<BaseDialogMapDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BaseDialoMapDetailDialogData
  ) {
  }

  onClose() {
    this.dialogRef.close();
  }

  isChacraItem() {
    return this.data.graphicAttr === GRAPHIC_ATTRS.CHACRA;
  }
}
